import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder } from '../http';

var validateOptions = function validateOptions(functionName, requiredOptions, options) {
  var typesRequiringKapp = ['Kapp', 'Form', 'Submission'];
  var kappSlug = options.kappSlug,
      _options$webhook = options.webhook,
      webhook = _options$webhook === void 0 ? {} : _options$webhook;
  var kappSlugMissing = typesRequiringKapp.includes(webhook.type) && !kappSlug;
  var missing = requiredOptions.filter(function (requiredOption) {
    return !options[requiredOption];
  });

  if (missing.length > 0) {
    throw new Error("".concat(functionName, " failed! The following required options are missing: ").concat(missing));
  }

  if (kappSlugMissing) {
    throw new Error("".concat(functionName, " failed! A kappSlug is required when using type: ").concat(webhook.type));
  }
};

var buildEndpoint = function buildEndpoint(_ref) {
  var kappSlug = _ref.kappSlug,
      webhookName = _ref.webhookName;
  var basePath = kappSlug ? "".concat(bundle.apiLocation(), "/kapps/").concat(kappSlug, "/webhooks") : "".concat(bundle.apiLocation(), "/webhooks");
  return webhookName ? "".concat(basePath, "/").concat(webhookName) : basePath;
};

export var fetchWebhooks = function fetchWebhooks() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchWebhooks', [], options);
  return axios.get(buildEndpoint(options), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      webhooks: response.data.webhooks
    };
  })["catch"](handleErrors);
};
export var fetchWebhook = function fetchWebhook() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchWebhook', ['webhookName'], options);
  return axios.get(buildEndpoint(options), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      webhook: response.data.webhook
    };
  })["catch"](handleErrors);
};
export var createWebhook = function createWebhook() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var webhook = options.webhook,
      kappSlug = options.kappSlug;
  validateOptions('createWebhook', ['webhook'], options); // For Creates, we don't append the name to the basePath (it goes in the body)
  // so not using the buildEndpoint function

  var basePath = kappSlug ? "".concat(bundle.apiLocation(), "/kapps/").concat(kappSlug, "/webhooks") : "".concat(bundle.apiLocation(), "/webhooks");
  return axios.post(basePath, webhook, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      webhook: response.data.webhook
    };
  })["catch"](handleErrors);
};
export var updateWebhook = function updateWebhook() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var webhook = options.webhook;
  validateOptions('updateWebhook', ['webhookName', 'webhook'], options);
  return axios.put(buildEndpoint(options), webhook, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      webhook: response.data.webhook
    };
  })["catch"](handleErrors);
};
export var deleteWebhook = function deleteWebhook() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('deleteWebhook', ['webhookName'], options);
  return axios["delete"](buildEndpoint(options), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      webhook: response.data.webhook
    };
  })["catch"](handleErrors);
};